'use client'
import {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";
import Title from "../Title";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import 'swiper/css/scrollbar';
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react"
import SliderNavLeft from "@/components/SliderNavLeft";
import SliderNavRight from "@/components/SliderNavRight";
import ImageParallax from "@/components/ImageParallax";

const MyComponent = ({title,data}) => {
    const containerRef = useRef(null);
    const [offset, setOffset] = useState()

    useEffect(() => {



        window.addEventListener('load', function () {
            setOffset(document.querySelector(' .container')?.offsetLeft)

        })
        window.addEventListener('resize', function () {
            setOffset(document.querySelector(' .container')?.offsetLeft)

        })
        setOffset(document.querySelector(' .container')?.offsetLeft)
    }, [])


    return (
        <StyledComponent offset={offset} className={'watch-section'} ref={containerRef} id={'value'}>
            <Container>
                <Row>
                    <Col>
                        <Title text={`Core <span>Values</span>`} margin={'80px 0 30px 0'} />
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col md={4}>
                        <div className="value-left-img">
                            <ImageParallax src={data?.images?.list?.[0]?.full_path} alt={'home-cta'}/>
                        </div>
                    </Col>
                    <Col md={{span:8}}>
                        <div className="value-slider-top">
                            <Title text={data?.section_data?.subtitle} margin={'100px 0 40px 70px'} />
                        </div>
                            <Swiper
                                // onSwiper={setSwiperInstance}
                                slidesPerView={3}
                                spaceBetween={30}
                                // autoplay={{
                                //     delay: 3000,
                                //     disableOnInteraction: false,
                                // }}
                                autoplay={false}
                                speed='500'
                                navigation={{
                                    prevEl: '.value-slider-bottom .go-left',
                                    nextEl: '.value-slider-bottom .go-right',
                                }}
                                initialSlide={0}
                                loop={false}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 30,

                                    },
                                    766: {
                                        slidesPerView: 2,
                                        spaceBetween: 30,

                                    },
                                    1024: {
                                        slidesPerView: 2,
                                        spaceBetween: 30,

                                    },
                                    1025: {
                                        slidesPerView: 3,
                                        spaceBetween: 30,
                                    },
                                    1701: {
                                        slidesPerView: 4,
                                        spaceBetween: 30,
                                    },
                                }}
                                modules={[Autoplay, Pagination, Navigation]}

                                className="mySwiper"
                            >
                                {
                                    data?.posts?.list.map((element,index) => {
                                        return(
                                            <SwiperSlide key={index} >
                                                <div className="testimonial-wrapper">
                                                    <div className="testimonial__single">
                                                        <img src={element?.images?.[0]?.full_path} alt=""/>
                                                        <h5>{element?.data?.title}</h5>
                                                        <h6>{element?.data?.description}</h6>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        )
                                    })
                                }

                            </Swiper>
                        <div className="value-slider-bottom">
                            <SliderNavLeft/>
                            <SliderNavRight/>
                        </div>
                    </Col>
                </Row>
            </Container>

        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    background-color: #f9f9f9;
    //margin-top: -400px;
    position: relative;
    will-change: transform;
    .management-team{
        margin-bottom: 30px;
    }
    .value-left-img{
        position: relative;
        padding-top: calc(778 / 498 * 100%);
        height: 100%;
        overflow: hidden;
        @media(min-width: 1500px){
            padding-top: calc(600 / 500 * 100%);
        }
    }
    .testimonial-wrapper{
      position: relative;
        height: 100%;
      &:hover{
          &:before{
              width: 100%;
          }
          &:after{
              height: 100%;
          }
      }
  }
  .testimonial__single{
    padding: 40px 30px 60px 30px;
    background-color: #FFF;
      border-radius: 5px;
      min-height: 100%;
      img{
          width: 66px;
          height: 60px;
          margin-bottom: 30px;
      }
      h5{
          font-size: 24px;
          line-height: 32px;
          font-weight: 800;
          margin-bottom: 30px;
          @media(min-width: 1920px){
              font-size: 28px;
              line-height: 32px;
          }
          @media(max-width: 768px){
              font-size: 20px;
              line-height: 28px;
          }
      }
      
      h6{
          font-size: 16px;
          line-height: 24px;
          font-weight: 500;
          @media(min-width: 1920px){
              font-size: 18px;
              line-height: 27px;
          }
      }
    }

  .value-slider-bottom{
    display: flex;
      justify-content: flex-start;
      margin-bottom: 100px;
      margin-top: 40px;
      margin-left: 70px;
      @media(max-width: 767px){
          justify-content: flex-start;
          margin-top: 30px;
      }
  }
  .container-fluid{
      // padding-left: ${props => props.offset ? props.offset +15+'px !important' : ''};
      .col-md-4, .col-md-8{
          padding: 0;
      }
      @media (max-width: 767px) {
          padding-left: 15px !important;
      }
      .col{
          padding-right: 0;
      }
  }
    .swiper-initialized {
        padding-right: ${props => props.offset ? props.offset +15+'px !important' : ''};
        margin-left: -150px;
        
        .swiper-slide{
            height: auto;
        }
        @media (min-width: 1500px) {
            padding-right: 140px;

        }
        @media (max-width: 767px) {
            padding-right: 75px !important;
        }
    }
    .container{
        display: none;
    }
    
    @media(max-width: 767px){
        .value-slider-top{
            display: none;
        }
        .container{
            display: block;
        }
        .value-left-img{
            width: 50%;
        }
        .swiper-initialized{
            margin-top: -530px;
            margin-left: 15px;
        }
        .testimonial__single{
            //width: 270px;
            //height: 350px;
        }
        .value-slider-bottom{
            margin-left: 15px;
            margin-bottom: 0;
            margin-top: 120px;
        }
        .value-left-img{
            img{
                height: 62svh !important;
            }
        }
        
    }
`;

export default MyComponent;
